import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/auth'
import { getPermissions } from '@/api/permission'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('accessToken') ? sessionStorage.getItem('accessToken') : null,
    identity: sessionStorage.getItem('identity') ? JSON.parse(sessionStorage.getItem('identity')) : null,
    permissions: sessionStorage.getItem('permissions') ? JSON.parse(sessionStorage.getItem('permissions')) : null
  },
  mutations: {
    SET_TOKEN (state, token, expiresIn) {
      state.token = token
      if (token === null) {
        sessionStorage.removeItem('accessToken')
      } else {
        sessionStorage.setItem('accessToken', token)
      }
    },
    SET_IDENTITY (state, identity) {
      state.identity = identity
      if (identity === null) {
        sessionStorage.removeItem('identity')
      } else {
        sessionStorage.setItem('identity', JSON.stringify(identity))
      }
    },
    SET_PERMISSION (state, permissions) {
      state.permissions = permissions
      console.log(permissions)
      sessionStorage.setItem('permissions', JSON.stringify(permissions))
    }
  },
  actions: {
    // 登录
    signin ({commit}, account) {
      return new Promise((resolve, reject) => {
        api.authorize(account).then(data => {
          let token = data.access_token
          let expiresIn = data.expires_in

          commit('SET_TOKEN', token)
          // 用于单点登录
          Vue.cookie.set('access_token', token, expiresIn)

          api.getInfo(token).then(data => {
            commit('SET_IDENTITY', data)
            
            commit('SET_PERMISSION', getPermissions(data))
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    signout ({commit}) {
      let token = this.state.token
      return new Promise((resolve, reject) => {
        api.signout(token).then(data => {
          commit('SET_TOKEN', null)
          Vue.cookie.del('access_token')
          commit('SET_IDENTITY', null)
          resolve()
        }).catch(error => {
          commit('SET_TOKEN', null)
          Vue.cookie.del('access_token')
          commit('SET_IDENTITY', null)
          reject(error)
        })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js